import type {
    DeviationDocuments,
    ReportDeviations,
    ReportDeviationsResponse,
} from '../../domain/model/deviation/Deviation.types';
import type {
    ApiReportDeviationsRequest,
    ApiReportDeviationsResponse,
} from './transportExecution.reportDeviations.schema';

export const toApiReportDeviations = (src: ReportDeviations): ApiReportDeviationsRequest => ({
    transferred_at: src.transferredAt,
    transfer_type: src.transferType,
    transport_leg_id: src.transportLegId,
    reported_by: {
        duns: src.reportedBy.duns,
        role: src.reportedBy.role,
    },
    baseline_packaging_id: src.baselinePackagingId,
    comment: src.comment,
    baseline_deviations: src.baselineDeviations.map(deviation => ({
        id: deviation.id,
        code: deviation.code,
        expected_quantity: deviation.expectedQuantity,
        actual_quantity: deviation.actualQuantity,
        damaged_quantity: deviation.damagedQuantity,
    })),
    additional_deviations: src.additionalDeviations.map(deviation => ({
        code: deviation.code,
        actual_quantity: deviation.actualQuantity,
        damaged_quantity: deviation.damagedQuantity,
    })),
});

export const toApiDeviationDocuments = (src: DeviationDocuments): FormData => {
    const formData = new FormData();

    formData.append('file', toApiDeviationDocumentFile(src.file));
    formData.append(
        'metadata',
        new Blob(
            [
                JSON.stringify({
                    reported_by: {
                        duns: src.metadata.reportedBy.duns,
                        role: src.metadata.reportedBy.role,
                    },
                    type: src.metadata.type,
                }),
            ],
            { type: 'application/json' }
        )
    );
    return formData;
};

const extensionToContentType = new Map([
    ['jpg', 'image/jpeg'],
    ['jpeg', 'image/jpeg'],
    ['png', 'image/png'],
    ['gif', 'image/gif'],
    ['pdf', 'application/pdf'],
]);

const toApiDeviationDocumentFile = (file: File): File => {
    const extension = file.name.split('.').pop()?.toLowerCase();
    const contentType = extension ? extensionToContentType.get(extension) : undefined;

    if (file.type || !contentType) {
        return file;
    }
    return new File([file], file.name, { type: contentType, lastModified: file.lastModified });
};

export const toReportDeviationsResponse = (src: ApiReportDeviationsResponse): ReportDeviationsResponse => ({
    transferConfirmationId: src.transfer_confirmation_id,
});
